import "./report-box-layout.scss";

interface IProps {
    children: React.ReactNode;
}

const ReportBoxLayout: React.FC<IProps> = ({ children }) => {
    return (
        <div className="report-box-layout">
            {children}
        </div>
    )
}

export default ReportBoxLayout;
